import { logout, getInfo } from "@/api/signUp";
import { removeUserId, getUserId, removeUserName, removeUserType } from '@/utils/userId'
import { removeToken } from '@/utils/token.js'
import { getDicts } from '@/api/home'
import { COMPET_CODE } from '@/utils/config.js'

const user = {
  state: {
    userInfo: {},
    competId: ''
  },
  mutations:{
    SET_USERINFO: (state, user) => {
      state.userInfo = user
    },
    SET_COMPET_ID: (state, id) => {
      state.competId = id
    }
  },
  actions: {
    // 获取用户信息
    GetInfo({commit}) {
      getInfo({ userId: getUserId() }).then(res => {
        commit('SET_USERINFO', res.data || {})
      })
    },
    GetCompetId({ commit, state }) {
      return new Promise((resolve, reject) => {
        getDicts('tswl_compet_project').then((res) => {
          let { data } = res 
          let num = data.findIndex((n) => n.value == COMPET_CODE)
          if (num !== -1) {
            commit('SET_COMPET_ID', data[num].label)
            localStorage.setItem('comprtId', data[num].label)
          } else {
            commit('SET_COMPET_ID', '')
            localStorage.setItem('comprtId', '')
          }
          resolve(data[num].label)
        }).catch(error => {
          reject(error)
        })
      })
    },
    async userLogout({ commit }) {
      let result = await logout();
      if (result.code === 0) {
        removeToken()
        removeUserId();
        removeUserName();
        removeUserType();
        commit('SET_USERINFO', {})
        commit('SET_COMPRT_ID', '')
        localStorage.setItem('comprtId', '')
      } else {
        throw new Error('failed');
      }
    },
  }
};

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js